import { render, staticRenderFns } from "./Osvdm.vue?vue&type=template&id=fc85c050&scoped=true&"
import script from "./Osvdm.vue?vue&type=script&lang=js&"
export * from "./Osvdm.vue?vue&type=script&lang=js&"
import style0 from "./Osvdm.vue?vue&type=style&index=0&id=fc85c050&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc85c050",
  null
  
)

export default component.exports